module.exports = __webpack_public_path__ + "img/inpost.60ea34b9.svg";